var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textbox',{staticClass:"readonly",attrs:{"value":_vm.value,"name":_vm.name,"readonly":"readonly","required":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }